import './forum.global.scss';

export { RichContentEditor, RichContentEditorModal } from 'wix-rich-content-editor';
export { TOOLBARS } from 'wix-rich-content-common';
export { createLinkPlugin, LINK_TYPE } from 'wix-rich-content-plugin-link';
export { createHashtagPlugin, HASHTAG_TYPE } from 'wix-rich-content-plugin-hashtag';
export { createImagePlugin, IMAGE_TYPE, ModalsMap as imageModals } from 'wix-rich-content-plugin-image';
export { createVideoPlugin, VIDEO_TYPE, ModalsMap as videoModals } from 'wix-rich-content-plugin-video';
export { createGalleryPlugin, GALLERY_TYPE, ModalsMap as galleryModals } from 'wix-rich-content-plugin-gallery';
export { createDividerPlugin, DIVIDER_TYPE } from 'wix-rich-content-plugin-divider';
export { createHtmlPlugin, HTML_TYPE } from 'wix-rich-content-plugin-html';
export {
  createExternalMentionsPlugin,
  EXTERNAL_MENTIONS_TYPE,
  getMentionsFromEditorState,
  addMentionToEditorState,
} from 'wix-rich-content-plugin-mentions';
export { createExternalEmojiPlugin, EXTERNAL_EMOJI_TYPE } from 'wix-rich-content-plugin-emoji';
export { createCodeBlockPlugin, CODE_BLOCK_TYPE } from 'wix-rich-content-plugin-code-block';
